import DemsRecipientsModuleTableColumns from '../dems/DemsRecipientsModuleTableColumns';
import DemsRecipientsExternalModuleTableColumns from '../dems/dems-recipients/DemsRecipientsExternalModuleTableColumns';
import InvoicesModuleTableColumns from '../../submodules/invoices/InvoicesModuleTableColumns';
import OrdersLinesTableColumns from '../orders/lines/OrdersLinesTableColumns';
import OrdersBillingTableColumns from '../orders/billing/OrdersBillingTableColumns';

const tablesColumns = {
	dems_recipients: DemsRecipientsModuleTableColumns,
	dems_recipients_external: DemsRecipientsExternalModuleTableColumns,
	invoices: InvoicesModuleTableColumns,
	orders_billing: OrdersBillingTableColumns,
	orders_lines: OrdersLinesTableColumns
};

export default tablesColumns;
